<template>
  <div class="layout-template-dialog"
       @click="toggleVisible">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :title="title"
                    :visible.sync="visible"
                    v-bind="$attrs"
                    v-on="$listeners">
      <slot name="content"
            :visible="visible"
            :hide-popover="hidePopover"></slot>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from './grid/DataGridDialog'
export default {
  name: 'TemplateDialog',
  components: {
    DataGridDialog
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hidePopover () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
  .layout-template-dialog {
    display: inline-block;
  }
</style>
